import { render } from "./ThermometerIcon.vue?vue&type=template&id=39f2ec6a"
import script from "./ThermometerIcon.vue?vue&type=script&lang=ts"
export * from "./ThermometerIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script